import { render, staticRenderFns } from "./ShowOrEditDocumentsClient.vue?vue&type=template&id=73158ba8&"
import script from "./ShowOrEditDocumentsClient.vue?vue&type=script&lang=js&"
export * from "./ShowOrEditDocumentsClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports